// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".d9864b4d4075325e773514efa6742f881a3007a2.chunk.bundle.js";
};